
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getSchedule = async () => {
  return await get<ApiResponse<any[]>>("/schedule").then((res)=>{
      return res
    })
};

 